
import Vue from 'vue'

import QuantityInput from '@/common/components/QuantityInput.vue'
import { SERVER_ERRORS } from '@/product/const'
import { Estimate } from '@/model/estimate'

export default Vue.extend({
  components: {
    QuantityInput
  },
  data(): {
    showModalPriceTable: boolean
    updatingQuantity: boolean
  } {
    return {
      showModalPriceTable: false,
      updatingQuantity: false
    }
  },
  computed: {
    estimate(): Estimate {
      return this.$store.getters.estimate
    },
    trial() {
      return this.estimate.trial
    },
    quantities() {
      return this.$store.getters.quantities
    },
    product() {
      return this.$store.getters.product
    },
    showQuantityInput(){
      return !this.estimate.trial && this.quantities && this.quantities.quantity
    },
    printCapacity() {
      return this.estimate.print_capacity_per_day?.remaining_quantity
    },
    trialErrorMessage() {
      return this.$store.state.serverError && this.$store.state.serverError.code  === SERVER_ERRORS.NO_TRIAL_SUPPORT
        ? this.$store.state.serverError.message
        : ''
    }
  },
  mounted() {
    if (this.printCapacity !== undefined && this.quantities.quantity > this.printCapacity) {
      this.$store.commit('setValidQuantity', false)
    }
  },
  methods: {
    onChangeQuantity({ quantity, hasErrors }) {
      if (hasErrors) {
        this.validateQuantity(false)
        this.$store.commit('setUpdatingQuantityInput', false)
        return
      }
      this.validateQuantity(true)
      this.$store.commit('setQuantity', quantity)
      this.$emit('refreshProductInfo', { disabledLoading: true })
      this.$store.commit('setUpdatingQuantityInput', false)
    },
    onCheckValidation({ hasErrors }) {
      if (this.trial) {
        this.validateQuantity(true)
        return
      }
      if (hasErrors) {
        this.validateQuantity(false)
        return
      }
      this.validateQuantity(true)
    },
    validateQuantity(valid: boolean) {
      this.$store.commit('setValidQuantity', valid)
      this.$store.commit('setValidLatestQuantityInputValue', valid)
    },
    onUpdatingQuantity() {
      this.$store.commit('setUpdatingQuantityInput', true)
    }
  }
})
